import { css } from "@emotion/react";

export const headerStyle = css`
  display: flex;
  justify-content: space-between;
`;

export const triggerStyle = css`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font: inherit;
`;

export const panelStyle = css`
  contain: layout;
  overflow: hidden;
  will-change: height, opacity;

  [data-collapsible-ready="0"] & {
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;
